import React, { Fragment } from 'react';
// types
import PropTypes from 'prop-types';

// redux
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { getNextOnboardingRoute } from './accountCompletionValidators';

// routes
import accountRoutes from './accountRoutes';
import { Route, Switch, Redirect } from 'react-router-dom';

// hocs
import withLayout from '../withLayout';

// Components
import AccountListItems from './AccountListItems';
import AccountDialog from './AccountDialog';

function capitalizeFirstLetter(word) {
  return `${word[0].toUpperCase()}${word.slice(1)}`;
}

class Account extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      suitabilityDialogOpen: false,
      qualificationDialogOpen: false,
      offersDialogOpen: false,
      openDialogue: false,
      dialogType: 'basic-information',
    };
  }

  componentWillReceiveProps(nextProps) {
    const { canViewOffers } = this.props.investorUser;

    const canAccessOffers =
      !canViewOffers && nextProps.investorUser.canViewOffers;

    if (canAccessOffers) this.handleDialogOpen('offers');
  }

  handleDialogOpen = (dialogType) => {
    this.setState({ [`${dialogType}DialogOpen`]: true });
  };

  handleDialogClose = () => {
    this.setState({
      offersDialogOpen: false,
      suitabilityDialogOpen: false,
      qualificationDialogOpen: false,
      openDialogue: false,
    });
  };

  render() {
    const { investorUser, match, dispatch, tenant, isAuthenticated } =
      this.props;
    const suitabilityComplete = Boolean(investorUser.suitability);

    const suitabilityRequired = (pathname) => {
      if (pathname === '/account/verification' && !suitabilityComplete)
        return true;
      if (pathname === '/account/affiliations' && !suitabilityComplete)
        return true;
      if (pathname === '/account/preferences' && !suitabilityComplete)
        return true;
      return false;
    };

    return (
      <Fragment>
        <div className='section'>
          <div className='max-width-div w-clearfix'>
            <AccountListItems
              investorUser={investorUser}
              suitabilityRequired={suitabilityRequired}
              handleDialogOpen={(val) => {
                this.setState({
                  openDialogue: true,
                  dialogType: val,
                });
                // return this.handleDialogOpen(val);
              }}
              // handleDialogOpen={() => this.handleDialogOpen('suitability')}
            />

            <Switch>
              {Object.keys(accountRoutes).map((pathname) => (
                <Route
                  key={pathname}
                  exact
                  path={pathname}
                  render={() => {
                    const Component = accountRoutes[pathname].component;

                    return suitabilityRequired(pathname) ? (
                      <Redirect to='/account/suitability' />
                    ) : (
                      <Component />
                    );
                  }}
                />
              ))}
              <Route
                component={() => (
                  <Redirect to={`${match.url}/basic-information`} />
                )}
              />
            </Switch>
          </div>
        </div>
        <AccountDialog
          dialogTitle={
            capitalizeFirstLetter(this.state.dialogType) + ' Form Required'
          }
          dialogContent={
            'To access this section you must first complete the ' +
            this.state.dialogType +
            ' Form.'
          }
          leftButtonText='close'
          rightButtonText={'complete ' + this.state.dialogType}
          dialogOpen={this.state.openDialogue}
          leftButtonAction={() => {
            this.handleDialogClose();
          }}
          rightButtonAction={() => {
            this.handleDialogClose();
            dispatch(push('/account/' + this.state.dialogType));
          }}
          handleDialogClose={this.handleDialogClose}
        />
        <AccountDialog
          dialogTitle='Suitability Form Required'
          dialogContent='To access this section you must first complete the Suitability Form.'
          leftButtonText='close'
          rightButtonText='complete suitability'
          dialogOpen={this.state.suitabilityDialogOpen}
          leftButtonAction={() => {
            this.handleDialogClose();
          }}
          rightButtonAction={() => {
            this.handleDialogClose();
            dispatch(push('/account/suitability'));
          }}
          handleDialogClose={this.handleDialogClose}
        />
        <AccountDialog
          dialogTitle='Offers Available'
          dialogContent='You can now view offers.'
          leftButtonText='continue registration'
          rightButtonText={
            localStorage.getItem('desiredRoute') ? 'View Offer' : 'View Offers'
          }
          dialogOpen={this.state.offersDialogOpen}
          leftButtonAction={() => {
            this.handleDialogClose();
            dispatch(push(getNextOnboardingRoute(this.props)));
          }}
          rightButtonAction={() => {
            this.handleDialogClose();
            const desiredRoute =
              localStorage.getItem('desiredRoute') || '/dashboard';
            dispatch(push(desiredRoute));
          }}
          handleDialogClose={this.handleDialogClose}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  investorUser: state.investorUser,
  location: state.router.location,
});

Account.propTypes = {
  investorUser: PropTypes.object.isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(withLayout(Account));



// WEBPACK FOOTER //
// ./src/components/Account/index.js